import { useQuery } from '@apollo/client';
import classNames from 'classnames/bind';
import { AP_CODES } from 'contexts/searchParams';
import RecommendItem from 'everywhere/common/list/recommendItem';
import GET_RECOMMEND_FLIGHT from 'everywhere/monthly/recommend.gql';
import { IData } from 'everywhere/monthly/types';
import { formatRecommends } from 'everywhere/monthly/utils';
import Link from 'next/link';
import { useMemo } from 'react';
import styles from './index.module.scss';
import Map from './map';

const cx = classNames.bind(styles);

const MAX_DESTINATION_COUNT = 4;

export default function Everywhere() {
  const { data } = useQuery<IData>(GET_RECOMMEND_FLIGHT, {
    variables: {
      internationalOnly: true,
      recommendOnly: true,
      scity: AP_CODES.SEOUL,
      size: MAX_DESTINATION_COUNT,
    },
  });

  const list = useMemo(
    () => formatRecommends(data?.recommend.list || []),
    [data],
  );

  if (!data) {
    return null;
  }

  return (
    <div className={cx('Everywhere')}>
      <h3 className={cx('title')}>
        <span className={cx('skippable')}>전 세계 인기 항공권 </span>모든 곳
        검색
      </h3>
      <div className={cx('container')}>
        <Link
          className={cx('anchor')}
          href="/flights/everywhere/monthly/SEL?viewType=map"
          data-event-nlog="click"
          data-event-area-code="mai.mapview"
        >
          <Map list={list} />
        </Link>
        <div className={cx('card_list')}>
          {data.recommend.list.map(item => (
            <Link
              key={item.arrivalCity.iataCode}
              className={cx('anchor')}
              href="/flights/everywhere/monthly/SEL"
              data-event-nlog="click"
              data-event-area-code="mai.listview"
            >
              <RecommendItem
                cityImage={item.cityImage}
                departureCityName={item.departureCity.cityName}
                departureCityCode={item.departureCity.iataCode}
                arrivalCityName={item.arrivalCity.cityName}
                arrivalCityCode={item.arrivalCity.iataCode}
                stops={item.stops}
                duration={item.duration}
                price={item.fare}
              />
            </Link>
          ))}
        </div>
      </div>
      <Link
        className={cx('more')}
        href="/flights/everywhere/monthly/SEL"
        title="인기 항공권 더보기"
        data-event-nlog="click"
        data-event-area-code="mai.mapmore"
      >
        <span className={cx('skippable')}>
          출발일, 지역, 소요시간, 여행기간, 가격 맞춤검색
        </span>
      </Link>
    </div>
  );
}
